/* istanbul ignore file */
export { default } from './Select';
